import React from 'react';
import styles from './stockStyles';
import TradingViewWidget from 'react-tradingview-widget';
import { Paper, Typography } from '@material-ui/core';

const StockChart = ({ symbol }) => {
  return (
    <div style={styles.stockContainer}>
      {symbol && (
        <Paper elevation={5} style={styles.stockPaper} className="sticky">
          <TradingViewWidget
            symbol={symbol}
            referral_id="13279"
            width="100%"
            height={250}
            // hide_top_toolbar={true}
            hide_legend={true}
            hide_ideas={true}
            save_image={false}
            toolbar_bg="#f1f3f6"
            container_id="basic-area-chart"
          />
          <Typography
            variant="body1"
            component="p"
            style={
              window.innerWidth < 1440
                ? styles.stockDelayTextSmall
                : styles.stockDelayText
            }
          >
            Stock prices in chart are delayed by 15 minutes.
          </Typography>
        </Paper>
      )}
    </div>
  );
};

export default StockChart;



// WEBPACK FOOTER //
// ./src/Pages/Stock/StockChart.js